var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.reports },
    [
      _c("reports-title", { attrs: { title: _vm.pageTitle } }),
      _vm._v(" "),
      _c("reports-toolbar", {
        attrs: {
          "report-title": _vm.pageTitle,
          "toolbar-disabled": !_vm.projects.length,
        },
        on: { onExportPortfolioReport: _vm.onExportPortfolioReport },
      }),
      _vm._v(" "),
      _c("tanstack-table", {
        ref: "tableRef",
        attrs: {
          id: "report_export_id",
          "is-full-height": true,
          config: _vm.tableConfig,
        },
        on: {
          contextMenu: _vm.contextMenu,
          sortingChanged: _vm.sortingChanged,
        },
      }),
      _vm._v(" "),
      _vm.isShowStub
        ? _c("div", { class: _vm.$style.stub_with_image }, [
            _c(
              "div",
              { class: _vm.$style.wrapper },
              [
                _c("vgp-svg-image", {
                  attrs: { name: "comment-hub-no-search" },
                }),
                _vm._v(" "),
                _c("div", { class: _vm.$style.desc }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.locale("report_page_no_filtered_data")) +
                      "\n      "
                  ),
                ]),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }